import { z } from 'zod'
import { responseSchema } from '@/core/types/Response.ts'
import { requireOTPSchema } from '@/modules/sales/clients/types/RequireOTP.ts'

export const requireOTPApiValidationResponseSchema =
  responseSchema(requireOTPSchema)

export type RequireOTPResponse = z.infer<
  typeof requireOTPApiValidationResponseSchema
>
